export const services = [
  {
    logo: '/path/to/logo1.png',
    description: 'Useful Service 1 Description',
    url: '/service1',
  },
  {
    logo: '/path/to/logo2.png',
    description: 'Useful Service 2 Description',
    url: '/service2',
  },
  {
    logo: '/path/to/logo3.png',
    description: 'Useful Service 3 Description',
    url: '/service3',
  },
  {
    logo: '/path/to/logo3.png',
    description: 'Useful Service 3 Description',
    url: '/service3',
  },
  {
    logo: '/path/to/logo3.png',
    description: 'Useful Service 3 Description',
    url: '/service3',
  },
  {
    logo: '/path/to/logo3.png',
    description: 'Useful Service 3 Description',
    url: '/service3',
  },
];
